import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
import { BufferGeometry } from './BufferGeometry.js';

var InstancedBufferGeometry = /*#__PURE__*/function (_BufferGeometry) {
  _inheritsLoose(InstancedBufferGeometry, _BufferGeometry);

  function InstancedBufferGeometry() {
    var _this;

    _this = _BufferGeometry.call(this) || this;
    _this.type = 'InstancedBufferGeometry';
    _this.instanceCount = Infinity;
    return _this;
  }

  var _proto = InstancedBufferGeometry.prototype;

  _proto.copy = function copy(source) {
    _BufferGeometry.prototype.copy.call(this, source);

    this.instanceCount = source.instanceCount;
    return this;
  };

  _proto.clone = function clone() {
    return new this.constructor().copy(this);
  };

  _proto.toJSON = function toJSON() {
    var data = _BufferGeometry.prototype.toJSON.call(this, this);

    data.instanceCount = this.instanceCount;
    data.isInstancedBufferGeometry = true;
    return data;
  };

  return InstancedBufferGeometry;
}(BufferGeometry);

InstancedBufferGeometry.prototype.isInstancedBufferGeometry = true;
export { InstancedBufferGeometry };